module.exports = __webpack_public_path__ + "static/media/Cofee.987906e8.png";